<div class="nxe-menu-bar">
  <div class="nxe-menu-bar-left">
    @if (featCreateDir) {
      <button class="nxe-menu-bar-button create-folder-icon" (click)="createDir()" matTooltip="New Folder"
              matTooltipPosition="above">
        <i-tabler name="folder-plus" style="vertical-align: middle;"></i-tabler>
        <!--<i class="nxe-folder" aria-hidden="true"></i>-->
      </button>
    }

    <button class="nxe-menu-bar-button refresh-icon" (click)="refresh()" matTooltip="Refresh"
            matTooltipPosition="above">
      <i-tabler name="zoom-reset" class="icon-28" style="vertical-align: middle;"></i-tabler>
      <!--<i class="nxe-arrows-cw" aria-hidden="true"></i> Refresh-->
    </button>

    @if (featUpload) {
      <button class="nxe-menu-bar-button upload-icon" (click)="openUploader()" matTooltip="Upload"
              matTooltipPosition="above">
        <i-tabler name="file-upload" class="icon-28" style="vertical-align: middle;"></i-tabler>
        <!--<i class="nxe-upload" aria-hidden="true"></i> Upload-->
      </button>
    }

    @if (featDownload) {
      <button class="nxe-menu-bar-button download-icon" [disabled]="!(canDownload$ | async)" (click)="download()" matTooltip="Download"
              matTooltipPosition="above">
        <i-tabler name="file-download" class="icon-28" style="vertical-align: middle;"></i-tabler>
        <!--<i class="nxe-download" aria-hidden="true"></i> Download-->
      </button>
    }

    @if (featRename) {
      <button class="nxe-menu-bar-button edit-icon" [disabled]="!(canRename$ | async)" (click)="rename()" matTooltip="Rename"
              matTooltipPosition="above">
        <i-tabler name="edit" class="icon-28" style="vertical-align: middle;"></i-tabler>
        <!--<i class="nxe-edit" aria-hidden="true"></i> Rename-->
      </button>
    }

    @if (featDelete) {
      <button class="nxe-menu-bar-button delete-icon" [disabled]="!(canDelete$ | async)" (click)="remove()" matTooltip="Delete"
              matTooltipPosition="above">
        <i-tabler name="trash-x" class="icon-28" style="vertical-align: middle;"></i-tabler>
        <!--<i class="nxe-trash-empty" aria-hidden="true"></i> Delete-->
      </button>
    }

    @if (featViewFile) {
      <button class="nxe-menu-bar-button view-icon" [disabled]="!(canView$ | async)" (click)="viewFile()" matTooltip="View"
              matTooltipPosition="above">
        <i-tabler name="eye" class="icon-28" style="vertical-align: middle;"></i-tabler>

      </button>
    }

    @if (featSendFile && showSendFile) {
      <button class="nxe-menu-bar-button send-icon" [disabled]="!(canSendFile$ | async)" (click)="sendFile()" matTooltip="Send File"
              matTooltipPosition="above">
        <i-tabler name="file-export" class="icon-28" style="vertical-align: middle;"></i-tabler>
      </button>
    }
    @else if (featSendFile && showEditFile) {
      <button class="nxe-menu-bar-button send-icon" [disabled]="!(canEditFile$ | async)" (click)="editFile()" matTooltip="Edit File"
              matTooltipPosition="above">
        <i-tabler name="photo-edit" class="icon-28" style="vertical-align: middle;"></i-tabler>
      </button>
    }
  </div>
  <div class="nxe-menu-bar-right">
    @if (showSwitcher) {
      <nxe-view-switcher></nxe-view-switcher>
    }
  </div>
  <input style="display: none" type="file" multiple (change)="handleFiles($event)" #uploader/>
</div>
